module.exports = __webpack_public_path__ + "img/net.25949174.png";